module.exports = __webpack_public_path__ + "staticcomp/img/cover.ca1ddf4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/8/cover.jpg
// module id = XP2f
// module chunks = 39